import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { unsavedChangesGuard, UNSAVED_MESSAGE_KEY, UNSAVED_TITLE_KEY } from '../../../lib/guards/unsaved-changes.guard';
import { BRAND_CONFIG } from './base/brand-config';

/**
 * Brand 라우팅 (rxResource 전환)
 *
 * Modern Angular 21+ 패턴:
 * - ❌ Resolver 제거 (느린 라우트 전환 해결)
 * - ✅ Component-level rxResource (즉시 라우트 전환)
 * - ✅ Lazy loading
 * - ✅ Config-Driven routePath
 *
 * ⚠️ 중요: routePath는 Legacy URL과 동일하게 설정!
 * Legacy URL: /master/brand
 * Modern URL: /master/brand (동일)
 */
export const brandRoutes: Routes = [
  {
    path: BRAND_CONFIG.routePath,
    canActivate: [roleGuard('ADMIN_MASTER')],
    data: {
      title: 'Brand 목록',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/brand-list-page/brand-list-page.component'
          ).then((m) => m.BrandListPageComponent),
        children: [
          {
            path: ':id',
            canDeactivate: [unsavedChangesGuard],
            loadComponent: () =>
              import(
                './components/smart/brand-detail-page/brand-detail-page.component'
              ).then((m) => m.BrandDetailPageComponent),
            data: {
              title: 'Brand 상세',
              [UNSAVED_MESSAGE_KEY]: 'brandChapter.leave.message',
              [UNSAVED_TITLE_KEY]: 'brandChapter.leave.title',
            },
          },
        ],
      },
    ],
  },
];
